import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import TagManager from "react-gtm-module";
const tagManagerArgs = {
  gtmId: "GTM-533LVMX5", // Replace this with your actual GTM ID
};
TagManager.initialize(tagManagerArgs);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
